import React from 'react'
import './Controls.css'

const ControlText = (props) => (
  <div className={props.error ? 'control control--err' : 'control'}>
    <input
      type='text'
      name={props.name}
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      className={props.lg ? 'control__text control__text--lg' : 'control__text'}
      disabled={props.disabled}
    />
  </div>
)

const ControlTextArea = (props) => (
  <div className={props.error ? 'control control--err' : 'control'}>
    <textarea
      rows={props.rows}
      name={props.name}
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      className='control__textarea'
      disabled={props.disabled}
    />
  </div>
)

const ControlEmail = (props) => (
  <div className={props.error ? 'control control--err' : 'control'}>
    <input
      type='email'
      name='email'
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      className={props.lg ? 'control__email control__email--lg' : 'control__email'}
      disabled={props.disabled}
    />
  </div>
)

const ControlNumber = (props) => (
  <div className={props.error ? 'control control--err' : 'control'}>
    <input
      type='number'
      name={props.name}
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      className={props.lg ? 'control__text control__text--lg' : 'control__text'}
      disabled={props.disabled}
    />
  </div>
)

const ControlPassword = (props) => (
  <div className={props.error ? 'control control--err' : 'control'}>
    <input
      type='password'
      name='password'
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      className={props.lg ? 'control__password control__password--lg' : 'control__password'}
    />
  </div>
)

const ControlSearch = (props) => (
  <div className={props.error ? 'control control--err' : 'control'}>
    <input
      type='text'
      name={props.name}
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      className={props.result ? 'control__text' : 'control__text control__text--not_found'}
    />
    {props.list.length > 0 && <div className='control__list'>
      <ul>
        {props.list.map((item) => (<li key={item.id} onClick={() => props.onClick(item.nombre, item.id)}>{item.nombre}</li>))}
      </ul>
    </div>}
  </div>
)

const ControlSwitch = (props) => (
  <div className='control'>
    <label className='control__switch'>
      <input type='checkbox' checked={props.value} onChange={props.onChange} />
      <span />
    </label>
  </div>
)

const ControlSelect = (props) => (
  <div className='control control_after--select'>
    <select value={props.value} className='control__select' onChange={props.onChange}>
      <option value='' disabled>{props.placeholder}</option>
      {props.options.map((opt, i) => <option value={opt.value} key={i}>{opt.label}</option>)}
    </select>
  </div>
)

export { ControlText, ControlTextArea, ControlEmail, ControlNumber, ControlPassword, ControlSearch, ControlSwitch, ControlSelect }
